import React from 'react';
import CreatableSelect from 'react-select/creatable';

import CustomDropdown from '@/components/CustomDropdown';
import CommonImage from '@/components/CommonImage';

const SendToPdModal = () => {
	return (
		<div className="popup-wrapper width-720-modal">
			<div className="common-popup sample-request-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">Send to PD</h3>
					</div>
					<div className="close-btn">
						<CommonImage alt="close" src="/icons/close.svg" />
					</div>
				</div>
				<div className="common-popup-body">
					<div className="send-information-flied">
						<div className="flied-item d-grid grid-columns-3 gap-3">
							<div className="single-flied-item">
								<div className="form-group">
									<label htmlFor="collection">Primary target customer*</label>
									<CustomDropdown
										title="Project type*"
										onItemClick={() => {}}
										selectedItem={''}
										items={[]}
									/>
								</div>
							</div>
							<div className="single-flied-item">
								<div className="form-group">
									<label htmlFor="collection">Project name</label>
									<CustomDropdown
										title="Project type*"
										onItemClick={() => {}}
										selectedItem={''}
										items={[]}
									/>
								</div>
							</div>
							<div className="single-flied-item">
								<div className="form-group">
									<label htmlFor="collection">Sample Type*</label>
									<CustomDropdown
										title="Project type*"
										onItemClick={() => {}}
										selectedItem={''}
										items={[]}
									/>
								</div>
							</div>
						</div>
						<div className="flied-item d-grid grid-columns-3 gap-3">
							<div className="single-flied-item">
								<div className="form-group">
									<label htmlFor="collection">Required date *</label>
									<input type="date" />
								</div>
							</div>
							<div className="single-flied-item">
								<div className="form-group no-shadow-react-select">
									<label htmlFor="collection">Send me sample copy to</label>
									<CreatableSelect
										isMulti
										value={'TEST'}
										onChange={() => {}}
										options={[
											{ label: '01', value: 'Test', id: 1 },
											{ label: '02', value: 'Test1', id: 2 },
											{ label: '03', value: 'Test2', id: 3 }
										]}
										isClearable
									/>
								</div>
							</div>
							<div className="single-flied-item">
								<div className="form-group">
									<label htmlFor="collection">Expected Order Date *</label>
									<input type="date" />
								</div>
							</div>
						</div>
					</div>
					<div className="send-pd-table">
						<table className="table with-border">
							<thead>
								<tr>
									<th class="design-details-column">
										<span class="ml-2">Design(1)</span>
									</th>
									<th class="sample-details-column">Sample details</th>

									<th class="sample-details-column">Checklist*</th>
									<th class="sample-details-column">Remarks</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										<div className="d-flex align-items-center">
											<img
												src="https://d2939dhdpmjcbe.cloudfront.net/product/reference_image/2025/6/394/1749981041084_Screenshot_2025-03-10_at_10.00.45%E2%80%AFAM.png"
												alt="image"
												className="cell-img"
											/>
											<div className="ml-2">
												<p className="regular-12 gray_dark_01 py-1">MT25-A0187 </p>
												<ul className="common-list-component mb-2">
													<li>Men</li>
													<li>SWEATSHIRT</li>
												</ul>
											</div>
										</div>
									</td>
									<td>
										<p>Color, size & Qty</p>
									</td>
									<td>
										<div className="status">
											<span className="status green-3">Completed</span>
											{/* <span className="status red-3">Completed</span> */}
										</div>
									</td>
									<td className="remarks-column">
										<p>Remarks</p>
										{/* <textarea rows={1} /> */}
									</td>
								</tr>
								<tr className="row-error">
									<td>
										<div className="d-flex align-items-center">
											<img
												src="https://d2939dhdpmjcbe.cloudfront.net/product/reference_image/2025/6/394/1749981041084_Screenshot_2025-03-10_at_10.00.45%E2%80%AFAM.png"
												alt="image"
												className="cell-img"
											/>
											<div className="ml-2">
												<p className="regular-12 gray_dark_01 py-1">MT25-A0187 </p>
												<ul className="common-list-component mb-2">
													<li>Men</li>
													<li>SWEATSHIRT</li>
												</ul>
											</div>
										</div>
									</td>
									<td>
										<p>Color, size & Qty</p>
									</td>
									<td>
										<div className="status">
											<span className="status green-3">Completed</span>
											{/* <span className="status red-3">Completed</span> */}
										</div>
									</td>
									<td className="remarks-column">
										<textarea rows={1} />
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button size32 ml-2">Submit</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SendToPdModal;
